"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreakpointProvider = BreakpointProvider;
exports.useBreakpoint = useBreakpoint;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const __1 = require("..");
const is_browser_1 = require("../../helpers/is-browser");
const utils_1 = require("./utils");
const context_1 = require("../../context");
const Context = (0, react_1.createContext)(null);
/**
 * Провайдер, предоставляющий контекст для использования хуком useBreakpoint.
 * Не является обязательным, используется в целях оптимизации.
 * @param props Свойства.
 * @return Элемент.
 */
function BreakpointProvider({ children }) {
    const [contextValue, setRegistry] = (0, react_1.useState)(null);
    const { matchMedia } = (0, react_1.useContext)(context_1.MatchMediaContext);
    (0, __1.useIsomorphicLayoutEffect)(() => {
        (0, is_browser_1.isBrowser)() && setRegistry((0, utils_1.createRegistry)({ matchMedia }));
    }, []);
    return (0, jsx_runtime_1.jsx)(Context.Provider, { value: contextValue, children: children });
}
/**
 * Хук обработки медиа-запроса на основе breakpoint'а дизайн-системы.
 * @param query Запрос, например "xs+".
 * @return Соответствует ли ширина экрана заданному запросу.
 */
function useBreakpoint(query) {
    if (!utils_1.BreakpointQuery.isValid(query)) {
        throw Error(`useBreakpoint: Invalid query, "${query}"`);
    }
    const [, setRegistry] = (0, react_1.useState)(null);
    const registryFromContext = (0, react_1.useContext)(Context);
    const [matches, setMatches] = (0, react_1.useState)(false);
    const { matchMedia } = (0, react_1.useContext)(context_1.MatchMediaContext);
    (0, __1.useIsomorphicLayoutEffect)(() => {
        let registry;
        if (registryFromContext) {
            registry = registryFromContext;
        }
        else {
            registry = (0, utils_1.createRegistry)({ matchMedia });
        }
        setRegistry(registryFromContext);
        const subscription = registry.subscribe(query, e => {
            setMatches(e.matches);
        });
        setMatches(subscription.matches);
        return subscription.unsubscribe;
    }, [registryFromContext]);
    return matches;
}
//# sourceMappingURL=index.js.map